module.exports = __webpack_public_path__ + "static/img/norecord.c1043fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/norecord.png
// module id = xb9T
// module chunks = 1